import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { ProductPicture } from 'src/app/models/products/products';
import { ProductDetailsUiStateService } from '../../product-details-ui-state.service';

@Component({
  selector: 'app-picture-slider',
  templateUrl: './picture-slider.component.html',
  styleUrls: ['./picture-slider.component.scss']
})
export class PictureSliderComponent {
  @HostListener("document:keydown", ["$event"]) onKeyDown(e) {
    this.handleKeyboardEvents(e);
  }

  @Input() displayCurrentPic = false;
  @Input() currentPic: string;
  @Input() productPictureItems: ProductPicture[];

  
  preventDefault = false;
  isNotFirstLoad = false;
  enlargeBigPicture = false;
  constructor(private _pUiService: ProductDetailsUiStateService){
    
  }

  hideCurrentPicture(): void {
    if (!this.preventDefault) {
      this._pUiService.displayCurrentPicChange(false);
      document
        .querySelector(".anim-to-disable")
        ?.classList.remove("disable-anim");
      this.isNotFirstLoad = false;
      this.enlargeBigPicture = false;
      document
        .getElementById("viewport")
        .setAttribute(
          "content",
          "width=device-width, initial-scale=1, maximum-scale=1"
        );
    }
    this.preventDefault = false;
  }

  handleKeyboardEvents(event: KeyboardEvent): void {
    if (event.code === "Escape") {
      this.hideCurrentPicture();
    }
    if (event.code === "ArrowLeft") {
      this.moveCurrentPicNext(this.currentPic);
    } else if (event.code === "ArrowRight") {
      this.moveCurrentPictureBack(this.currentPic);
    }
  }

  moveCurrentPicNext(currentPic: string): void {
    let index = 0;
    this.productPictureItems.forEach(function (item, i) {
      if (item.Path === currentPic) {
        index = i;
      }
    });
    if (index < this.productPictureItems.length - 1) {
      this.currentPic = this.productPictureItems[index + 1].Path;
    } else {
      this.currentPic = this.productPictureItems[0].Path;
    }
    this.preventDefault = true;
  }

  moveCurrentPictureBack(currentPic: string): void {
    let index = 0;
    this.productPictureItems.forEach(function (item, i) {
      if (item.Path === currentPic) {
        index = i;
      }
    });
    if (index > 0) {
      this.currentPic = this.productPictureItems[index - 1].Path;
    } else {
      this.currentPic =
        this.productPictureItems[this.productPictureItems.length - 1].Path;
    }
    this.preventDefault = true;
  }

  preventClosingBigPic(): void {
    this.preventDefault = true;
  }
}
